import * as React from 'react';
import formats from '../../../../const/formats';
import * as moment from 'moment';
import { ITag } from '../../../../models/ITag';

type CompareVersionTagItemProps = {
    tag: ITag
}

function CompareVersionTagItem({ tag }: CompareVersionTagItemProps) {
    let tagName = tag.message;
    let isLast = false;

    if (tagName && tagName.toLowerCase() === 'last') {
        tagName = 'Last';
        isLast = true;
    }

    return (
        <div className="compare-version-tag-item">
            <div className="compare-version-tag-item_value">
                <span title={tagName}>{tagName}
                    {!isLast &&
                        <span className="compare-version-tag-item_value_date">
                            upd.:{moment(+tag.createTs).format(formats.MM_DD_YYYY_hh_mm_a)}
                        </span>}
                </span>
            </div>
        </div>
    );
}

export default CompareVersionTagItem;